import React, { useState } from "react";
import { Button } from "@/common/components/ui/button";
import { AlertCircle } from "lucide-react";
import IssueReportModal from "./IssueReportModal";

const IssueReportButton = ({
  issueType = "course",
  contextId = null,
  additionalData = {},
  variant = "outline",
  size = "sm",
  className = "",
  showIcon = true,
  children,
  mobileDisplay = "default", // 'default', 'icon-only', or 'text'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={`flex items-center gap-1 md:gap-2 ${className}`}
        onClick={handleOpenModal}
      >
        {showIcon && <AlertCircle className="w-4 h-4" />}

        {mobileDisplay === "icon-only" ? (
          <span className="hidden sm:inline whitespace-nowrap">
            {children || "Report Issue"}
          </span>
        ) : mobileDisplay === "text" ? (
          <>
            <span className="inline sm:hidden">{children || "Report"}</span>
            <span className="hidden sm:inline whitespace-nowrap">
              {children || "Report Issue"}
            </span>
          </>
        ) : (
          <span className="whitespace-nowrap">
            {children || "Report Issue"}
          </span>
        )}
      </Button>

      <IssueReportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        issueType={issueType}
        contextId={contextId}
        additionalData={additionalData}
      />
    </>
  );
};

export default IssueReportButton;
